import React, {Component} from 'react';


class Header extends Component {
    constructor(props) {
        super(props)

        this.menuClickWork = this.menuClickWork.bind(this);
        this.menuClickNews = this.menuClickNews.bind(this);
        this.globalToggle = this.globalToggle.bind(this);
        this.mobmenu = this.mobmenu.bind(this);

        this.state = {
            menuOpen: false,
            globalOpen: false,
            menuNewsOpen: false,
            mobmenuOpen:false
        }
    }

    globalToggle() {
        if(this.state.globalOpen){
            this.setState({globalOpen:false});
        }else{
            this.setState({globalOpen:true});
        }
    }

    menuClickWork() {
        console.log("WORK")
        if(this.state.menuWorkOpen){
            this.setState({menuWorkOpen:false});
        }else{
            this.setState({menuWorkOpen:true});
            this.setState({menuNewsOpen:false});
        }
    }

    mobmenu() {
        console.log("MOB")
        if(this.state.mobmenuOpen){
            this.setState({mobmenuOpen:false});
        }else{
            this.setState({mobmenuOpen:true});
        }
    }

    menuClickNews() {
        // console.log("NEWS")
        // if(this.state.menuNewsOpen){
        //     this.setState({menuNewsOpen:false});
        // }else{
        //     this.setState({menuNewsOpen:true});
        //     this.setState({menuWorkOpen:false});
        // }
        if(typeof window !== 'undefined'){
          var win = window.open("https://aecom.com/news", '_blank');
          win.focus();
        }


    }

    render() {

        return (
          <div className="aecomhead">




            <div className="aecom-header">
            <div className="ink-grid">
              <div className="column-group">
                <div className="all-100">
                    <div className="column-group">
                        <div className="all-20 push-left align-left">
                          <div className="Aecomheaderlogo">
                                  <a href="https://aecom.com" target="_blank" rel="noreferrer">

                                  <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 135 28.7" >
                                  <style type="text/css">
                                      .aecom_nav_logo{`{fill:#000000;}`}
                                  </style>
                                  <g className="aecom_nav_logo">
                                    <path className="aecom_nav_logo" style={{fill:"#000000"}} d="M123.1,28.1l0.1-16.2l-8.1,16.2h-3.5L108.7,12L104,28.1h-6.9l8.6-27.6h6.2l3.2,15.6l8-15.6h6.2l0.5,27.6H123.1
                                      z M92.7,15.3c1-4.7-0.7-8.3-4.3-9c-3.9-0.8-7.4,2.2-8.5,7.1c-1,4.7,0.7,8.3,4.3,9C88.1,23.2,91.6,20.2,92.7,15.3 M88.1,0.1
                                      c7.4,0.5,12,6.5,11.1,14.6c-0.9,8.3-7.5,14.4-15.1,13.9C76.8,28,72.2,22,73,14C73.9,5.7,80.6-0.5,88.1,0.1 M70.6,27.7
                                      c-1.8,0.9-4.8,1-6.1,1c-7.8,0-13-5.7-12.8-13.7C52,6.6,58.5,0,66.5,0c2.9,0,5.2,0.7,7.9,2.3l-1.3,6.6c-1.8-1.5-3.8-2.3-6.1-2.3
                                      c-4.8,0-8.3,3.4-8.5,8C58.4,19,61.2,22,65.6,22c1.4,0,4.1-0.1,6-1L70.6,27.7z M48.5,17.6H31.4l1-6.4h17.1L48.5,17.6z M52.4,7H33
                                      l1-6.4h19.4L52.4,7z M50.2,21.7H30.8l-1,6.4h19.4L50.2,21.7z M14.7,16.7l4-9.6h0.1l2,9.6H14.7z M23.3,28.1h6.6L23.5,0.5H16L3,28.1
                                      h6.9l2.3-5.4h9.9L23.3,28.1z"/>
                                  </g>
                                  </svg>
                                  </a>
                          </div>
                        </div>
                        <div className="xlarge-80 large-80 medium-100 hide-small hide-tiny xlarge-push-right xlarge-align-right large-push-right large-align-right">
                            <nav className="ink-navigation align-right push-right">
                            <ul className="menu horizontal">
                            <li className="aecom_nav_item"><a href="https://aecom.com/about-us/" target="_blank" rel="noreferrer">about us<span className="fa fa-angle-down fa-lg" aria-hidden="true"/></a></li>
                            <li className="aecom_nav_item"><a href="https://aecom.com/services/" target="_blank" rel="noreferrer">our work<span className="fa fa-angle-down fa-lg" aria-hidden="true"/></a></li>
                            <li className="aecom_nav_item"><a href="https://aecom.com/without-limits/" target="_blank" rel="noreferrer">insights<span className="fa fa-angle-down fa-lg" aria-hidden="true"/></a></li>
                            <li className="aecom_nav_item"><a href="https://aecom.com/careers" target="_blank" rel="noreferrer">careers</a></li>
                            <li className="aecom_nav_item"><a href="https://aecom.com/news" target="_blank" rel="noreferrer">news</a></li>
                            <li className="aecom_nav_item"><a href="https://investors.aecom.com/" target="_blank" rel="noreferrer">investors</a></li>
                            <li className="aecom_nav_item"><a href="https://aecom.com/offices/" target="_blank" rel="noreferrer">locations<span className="fa fa-angle-down fa-lg" aria-hidden="true"/></a></li>
                            <li className="aecom_nav_item"> <a href="https://aecom.com/?s="  target="_blank" rel="noreferrer"><span className="fa fa-search"></span></a></li>


                            </ul>
                            </nav>
                        </div>
                    </div>
                </div>
              </div>
            </div>

            </div>

            <div className="megaMenu hide hide-small hide-tiny">
              <div className="ink-grid">
                <div className="column-group horizontal-gutters">
                  <div className="xlarge-25 large-25 hide-medium hide-small hide-tiny push-left align-left">
                    <div className="column-group top-space">
                      <div className="all-100">
                        <div className="megatitle"></div>
                 
                      </div>
                    </div>
                  </div>
                  <div className="xlarge-75 large-75 medium-100 push-left align-left ">
                  <div className="column-group top-space horizontal-gutters">
                  <div className="xlarge-80 large-80 medium-100 push-left align-left ">
                  <div className="megatitle"></div>
                  </div>
                  </div>
                  <div className="column-group horizontal-gutters ">
                    <div className="xlarge-40 large-40 medium-40 push-left align-left ">

                          <div className="column-group gutters">
                            <div className="xlarge-40 hide-medium hide-large push-left align-left ">
               
                            </div>
                              <div className="xlarge-60 large-100 medium-100 push-left align-left megastory">
                                <div className="megatitle">About AECOM</div>
                                  <p>At AECOM, we believe infrastructure creates opportunity for everyone.</p>
                              </div>
                            </div>

                            <div className="column-group gutters">
                              <div className="xlarge-40 hide-medium hide-large push-left align-left ">
                
                              </div>
                                <div className="xlarge-60 large-100 medium-100 push-left align-left megastory">
                               
                                </div>
                              </div>


                    </div>

                    <div className="xlarge-40 large-40 medium-40 push-left align-left ">

                          <div className="column-group gutters">
                            <div className="xlarge-40 hide-medium hide-large push-left align-left ">

                            </div>
                              <div className="xlarge-60 large-100 medium-100 push-left align-left megastory">
                                <div className="megatitle">About AECOM</div>
                                  <p>At AECOM, we believe infrastructure creates opportunity for everyone.</p>
                              </div>
                            </div>

                            <div className="column-group gutters">
                              <div className="xlarge-40 hide-medium hide-large push-left align-left ">
 
                              </div>
                                <div className="xlarge-60 large-100 medium-100 push-left align-left megastory">
                                 
                              
                                </div>
                              </div>


                    </div>
                    <div className="xlarge-20 large-20 medium-20 push-left align-left megaside">


                    </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>



            </div>
        )
    }
}
export default Header;
